import React from 'react';

const Profile = ({ user }) => (
  <div>
      <section className="user-profile">
        <img alt="profilepic from google" src={user.photoURL} />
        <p>{user.displayName}</p>
      </section>
  </div>
)

export default Profile



// WEBPACK FOOTER //
// ./src/containers/profile.js